import * as angular from "angular";
import {IController} from "angular";
import * as _ from "lodash";

export class selfPickupStatusSelectCtrl implements IController {

  status: any;
  options: any;
  enableAll: any;
  onChange: Function;

  /* @ngInject */
  constructor(private selfPickupsConstants) {
  }

  $onInit() {
    if (!_.isLength(this.options)) {
      this.options = this.selfPickupsConstants.allStatuses;
    }
  };

  onChangeStatus(selectedStatus) {
    if (this.status !== selectedStatus) {
      this.onChange({status: selectedStatus});
    }
  }

}

angular
  .module('bringoz.admin.self-pickups')
  .component('selfPickupStatusSelect', {
    bindings: {
      status: '<',
      options: '<?',
      enableAll: '@?',
      onChange: '&'
    },
    template: require('./self-pickup-status-select.html').default,
    controller: selfPickupStatusSelectCtrl
  });
